<template>
  <div class="container">
    <div class="login-bg">
      <div class="col-sm-12 w-login-body" :class="{ row: $mq !== 'sm' }">
        <div v-show="isDebug" class="col-sm-6">
          <login :is-login-with-email="true" class="w-login-cnt" />
        </div>
        <div
          :class="{
            'col-sm-6': isDebug,
            'col-sm-6 col-sm-offset-3': !isDebug
          }"
        >
          <external-login class="w-login-cnt" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const OLD_MAESTROCONNECT_HOST = [
  {
    oldUrl: "tst.maestroconnect.scmgroup.com",
    newUrl: "tst-uwa.maestroconnect.scmgroup.com"
  },
  {
    oldUrl: "stg.maestroconnect.scmgroup.com",
    newUrl: "stg-uwa.maestroconnect.scmgroup.com"
  },
  {
    oldUrl: "maestroconnect.scmgroup.com",
    newUrl: "uwa.maestroconnect.scmgroup.com"
  },
  {
    oldUrl: "tst.cmsconnect.cms.it",
    newUrl: "tst-uwa.cmsconnect.cms.it"
  },
  {
    oldUrl: "stg.cmsconnect.cms.it",
    newUrl: "stg-uwa.cmsconnect.cms.it"
  },
  {
    oldUrl: "cmsconnect.cms.it",
    newUrl: "uwa.cmsconnect.cms.it"
  }
];

import ExternalLogin from "@/components/ExternalLoginComponent";
import Login from "@/components/LoginComponent";

export default {
  components: {
    ExternalLogin,
    Login
  },
  computed: {
    isDebug() {
      return this.$route.query.debug === "true";
    }
  },
  created() {
    // Clear Search
    this.$store.dispatch("Search/reset", { root: true });

    // -----------------------------------------------------------------------------------------------
    // --- 26/11/2020: Check if old URL application go to redirect new host with sso login enabled ---
    // -----------------------------------------------------------------------------------------------
    if (OLD_MAESTROCONNECT_HOST.findIndex(el => el.oldUrl === location.hostname) > -1) {
      const redirect = OLD_MAESTROCONNECT_HOST.find(el => el.oldUrl === location.hostname);
      const currentPath = location.href.split(location.origin)[1];
      window.open("https://" + redirect.newUrl + currentPath, "_self");
    }
  }
};
</script>
<style scoped lang="scss">
.login-bg {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: url("~@/assets/images/blur_background.jpg");
  background-size: cover;
  z-index: 1;
}
.w-login-cnt {
  max-width: 500px;
  border: 1px solid #979797;
  border-radius: 4px 4px 5px 5px;
  background-color: #ffffff;
  padding: 15px;
  position: relative;
  z-index: 2;
  margin: auto;
}
#modal-new-login-notification-text {
  color: #000;
  padding-top: 1rem;
  padding-bottom: 1rem;
  font-size: 2rem;
}
#modal-new-login-notification-url {
  color: #000;
  font-size: 2rem;
}
.modal-header-title {
  font-size: 2rem;
}
@media (min-width: 960px) {
  .row {
    margin-top: 10%;
  }
}
@media (max-width: 750px) {
  .w-login-cnt {
    margin-top: 50px;
  }
  .login-bg {
    background-repeat: no-repeat;
    background-attachment: fixed;
    bottom: auto;
    min-height: 100%;
  }
}
</style>
